// src/components/Spinner.js
import React from 'react';
import { ClipLoader } from 'react-spinners';

export default function Spinner({ size = 35, color = "#123abc", loading = true }) {
  return <ClipLoader size={size} color={color} loading={loading} />;
}
